export default __webpack_public_path__ + "static/media/BYMA.0bd63373.svg";